import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import Tooltip from "./Tooltip";

export function FormCard({
    title,
    description,
    summary,
    children,
    className = "",
    bodyClassName = "",
    titleClassName = "",
    headerClassName = "",
    collapsible = false,
    defaultOpen = true,
    tooltip,
}) {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const showCollapsedSummary = collapsible && !isOpen && summary;
    const openHeaderSpacing = headerClassName || "mb-8";

    return (
        <div
            className={`w-full surface-card p-8 ${className}`.trim()}
        >
            {(title || description || showCollapsedSummary) && (
                <div className={isOpen ? openHeaderSpacing : "mb-0"}>
                    <div className="flex items-start justify-between gap-4">
                        <div className="min-w-0 flex-1">
                            {title && (
                                <h2
                                    className={`inline-flex items-center gap-1.5 text-xl font-bold  ${titleClassName}`.trim()}
                                >
                                    <span>{title}</span>
                                    {tooltip && (
                                        <Tooltip content={tooltip} position="right" tooltipClassName="max-w-lg px-2 py-1">
                                            <span
                                                className="inline-flex shrink-0 cursor-help text-mute-400 hover:text-mute-600"
                                                aria-label={tooltip}
                                            >
                                                <FontAwesomeIcon icon={faInfoCircle} className="h-3.5 w-3.5" />
                                            </span>
                                        </Tooltip>
                                    )}
                                </h2>
                            )}
                            {description && (
                                <p className="text-sm text-mute-500 mt-1">{description}</p>
                            )}
                            {showCollapsedSummary && (
                                <p className="mt-2 text-sm font-medium text-mute-700">
                                    {summary}
                                </p>
                            )}
                        </div>

                        {collapsible && (
                            <button
                                type="button"
                                className="shrink-0 hover:text-mute-700"
                                onClick={() => setIsOpen((prev) => !prev)}
                                aria-expanded={isOpen}
                            >
                                <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                            </button>
                        )}
                    </div>
                </div>
            )}

            {(!collapsible || isOpen) && (
                <div className={bodyClassName}>{children}</div>
            )}
        </div>
    );
}

export function FormSection({ title, children, className = "", titleClassName = "" }) {
    return (
        <div className={className}>
            {title && (
                <h3 className={`text-lg font-semibold mb-4  ${titleClassName}`.trim()}>
                    {title}
                </h3>
            )}
            {children}
        </div>
    );
}

export function FormGrid({ children, className = "" }) {
    return (
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-x-12 ${className}`.trim()}>
            {children}
        </div>
    );
}

export default FormCard;
